export default "__VITE_ASSET__7d28fc52__"